export function getTileHeaderCapitalLetter(name: string): string {
  if (!name) {
    return 'A'
  }

  return name.charAt(0).toUpperCase()
}
